import { render, staticRenderFns } from "./WorkspaceUpdate.vue?vue&type=template&id=48306740&scoped=true"
import script from "./WorkspaceUpdate.vue?vue&type=script&lang=ts"
export * from "./WorkspaceUpdate.vue?vue&type=script&lang=ts"
import style0 from "./WorkspaceUpdate.vue?vue&type=style&index=0&id=48306740&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48306740",
  null
  
)

export default component.exports